import React from 'react';
import { TweenOneGroup } from 'rc-tween-one';

import { Table } from 'antd';
import { Checkbox } from '@/elements';
import './index.scss';

const TableContext = React.createContext(false);

const rowSelection = {
	onChange: (selectedRowKeys, selectedRows) => {
		console.log(
			`selectedRowKeys: ${selectedRowKeys}`,
			'selectedRows: ',
			selectedRows,
		);
	},
};

const getColumns = data => {
	if (data && data.length !== 0) {
		const keys = Object.keys(data[0]).filter(
			el => el !== 'key', //remove col 'clientReference' but keep id in data row
		);
		return keys.map((key, i) => {
			const title = () => {
				switch (key) {
					case 'clientReference':
						return 'ID';
					case 'name':
						return 'Name';
					case 'evacuationUserType':
						return 'User Type';
					case 'evacuationStatus':
						return 'Evac Status';
					case 'zoneId':
						return 'Current Zone';
				}
			};
			return {
				title,
				width: (key !== 'name' && 150) || 'auto',
				fixed:
					// (key === 'name' && 'left') ||
					(key === 'clientReference ' && 'left') || false,
				dataIndex: key,
				key: key,
				sorter: (a, b) => {
					return a[key].localeCompare(b[key]);
				},
				sortDirections: ['descend', 'ascend'],
			};
		});
	}
};
const formatData = (data, search) => {
	// ******** Status ********
	// ** public static final int NOT_MOVED = 0;
	// ** public static final int EVACUATING = 1;
	// ** public static final int EXITED = 2;
	// ******** user Types *********
	// ** public static final int REGULAR_MOBILITY_TYPE = 0;
	// ** public static final int MOBILITY_IMPAIRED_PERSONS_TYPE = 1;
	// ** public static final int EMERGENCY_TYPE = 2;
	const getType = type => {
		switch (type) {
			case 0:
				return 'Regular Mobility';
			case 1:
				return 'Mobility Impaired';
			case 2:
				return 'Emergency';
		}
	};
	const getStatus = status => {
		switch (status) {
			case 0:
				return 'Not Moved';
			case 1:
				return 'Evacuating';
			case 2:
				return 'Exited';
		}
	};
	let res = [];
	if (data && data.length !== 0) {
		res = data.map(row => {
			return {
				key: row.clientReference,
				clientReference: row.clientReference,
				name: row.name,
				evacuationUserType: getType(row.evacuationUserType),
				evacuationStatus: getStatus(row.evacuationStatus),
				zoneId: row.zoneId,
			};
		});
	}
	if (search !== '') {
		return res.filter(el => {
			return el.name.search(new RegExp(search, 'i')) >= 0;
		});
	}
	return res;
};

// ANIMATION
const onEnd = e => {
	const dom = e.target;
	dom.style.height = 'auto';
};
const enterAnim = [
	{
		opacity: 0,
		x: 30,
		backgroundColor: '#fffeee',
		duration: 0,
	},
	{
		height: 0,
		duration: 200,
		type: 'from',
		delay: 250,
		ease: 'easeOutQuad',
		onComplete: onEnd,
	},
	{
		opacity: 1,
		x: 0,
		duration: 250,
		ease: 'easeOutQuad',
	},
	{ delay: 1000, backgroundColor: '#fff' },
];
const leaveAnim = [
	{ duration: 250, opacity: 0 },
	{ height: 0, duration: 200, ease: 'easeOutQuad' },
];
const pageEnterAnim = [
	{
		opacity: 0,
		duration: 0,
	},
	{
		height: 0,
		duration: 150,
		type: 'from',
		delay: 150,
		ease: 'easeOutQuad',
		onComplete: onEnd,
	},
	{
		opacity: 1,
		duration: 150,
		ease: 'easeOutQuad',
	},
];
const pageLeaveAnim = [
	{ duration: 150, opacity: 0 },
	{ height: 0, duration: 150, ease: 'easeOutQuad' },
];
const animTag = $props => {
	return (
		<TableContext.Consumer>
			{isPageTween => {
				return (
					<TweenOneGroup
						component="tbody"
						enter={!isPageTween ? enterAnim : pageEnterAnim}
						leave={!isPageTween ? leaveAnim : pageLeaveAnim}
						appear={false}
						exclusive
						{...$props}
					/>
				);
			}}
		</TableContext.Consumer>
	);
};

const RollCallTable = ({
	data,
	search,
	loading,
	isPageChange,
	paginationChange,
}) => {
	const dataSrc = formatData(data, search);
	const columns = getColumns(dataSrc);
	return (
		<TableContext.Provider value={isPageChange}>
			<Table
				columns={columns}
				// rowSelection={rowSelection}
				size={'medium'}
				dataSource={dataSrc}
				scroll={{ x: 1125 }}
				components={{ body: { wrapper: animTag } }}
				onChange={paginationChange}
				pagination={{
					defaultPageSize: 15,
					showTotal: total => `${total} of ${data.length} `,
					showSizeChanger: true,
					size: 'small',
					pageSizeOptions: ['10', '15', '50', '100'],
				}}
			/>
		</TableContext.Provider>
	);
};

export default RollCallTable;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-roll-call-table/index.js